import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.href
      ? { '@id': `https://www.97yingshi.com${item.href}`, name: item.label }
      : { name: item.label },
  }));

  const categorySlug = items.length > 1 ? items[1]?.href?.replace('/category/', '') : null;
  const category = categorySlug ? categories.find((c) => c.slug === categorySlug) : null;

  return (
    <>
      <nav aria-label="面包屑导航" className="max-w-[1400px] mx-auto px-4 md:px-6 pt-20 pb-0">
        <ol className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-600"></i>
              )}
              {item.href && index < items.length - 1 ? (
                <Link to={item.href} className="hover:text-primary-400 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={index === items.length - 1 ? 'text-foreground-300 font-medium' : ''}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: schemaItems,
          }),
        }}
      />
    </>
  );
}